module.exports = __webpack_public_path__ + "img/0Q3B7166_BlackMatted.4bf528cb.jpg";